export class InternalServerError {
    status: boolean;
    statusCode: number;
    intlCode: number
    errorType: string;
    statusInfo: string;
    internalMessage: string;
    constructor(internalMessage: string ) {
        this.status = false;
        this.statusCode = 90000;
        this.intlCode = 99999;
        this.errorType = 'Server Side Errors';
        this.statusInfo = 'Something went wrong from Server or Database';
        this.internalMessage = internalMessage;
    }
}